import {ref, watch} from 'vue';
import {defineStore} from 'pinia';

export const useAppDataStore = defineStore('appData', () => {
  let appData = ref({
    priceApi: false,
    price: '43,99',
    usersource: '',
    partnertarif: '',
    time_buttons: [],
    region: '',
    s1: {
      value: '',
      options: [
        {
          name: 'Für mich selbst',
          value: 'Für mich selbst',
          className: 'icon--user'
        },
        {
          name: 'Für jemand anderen',
          value: 'Für jemand anderen',
          className: 'icon--users'
        }
      ]
    },
    s2: {
      value: '',
      options: [],
      zipCodeErrorVisible: false,
    },
    s3: {
      value: '',
      options: [
        { name: 'Ja', value: 'Ja', className: 'icon--check' },
        { name: 'Nein', value: 'Nein', className: 'icon--not-checked' },
        {
          name: 'beantragt',
          value: 'beantragt',
          className: 'icon--document-check'
        },
        { name: 'unklar', value: 'unklar', className: 'icon--question' }
      ],
      krankenkasse: {
        name: ''
      },
      value_2: '',
      options_2: [
        { name: 'Ja', value: 'Ja', className: 'icon--check' },
        { name: 'Nein', value: 'Nein', className: 'icon--not-checked' }
      ]
    },
    s4: {
      value: '',
      capacity: '',
      options: [
        { name: 'Nein, danke', value: false, className: 'icon--check' },
        { name: 'Wunschtermin', value: 'wunschtermin', className: 'icon--calendar-alt' },
        { name: 'Rückrufwunsch ', value: 'rückrufwunsch', className: 'icon--phone' }
      ],
      meeting_time: '',
      holiday: false
    },
    contact: {
      anrede: '',
      firstname: '',
      lastname: '',
      street: '',
      house_number: '',
      zip: '',
      zipOfContact: '',
      stadt: '',
      city: '',
      servicesID: '',
      phone: '',
      phone_prefix: '',
      email: '',
      meeting_times: [],
      meeting_times_api: '',
      meeting_times_api_ts: '',
      public_holidays: [],
      termin_select: false,
      installation_address_anrede: '',
      installation_address_firstname: '',
      installation_address_lastname: '',
      installation_address_street: '',
      installation_address_house_number: '',
      installation_address_zipOfContact: '',
      installation_address_stadt: '',
      installation_address_phone: '',
      installation_address_phone_prefix: '',
      installation_address_email: ''
    },
    installation_address_checkbox: true,
    datepickerFlag: false
  });
  return {appData}
  }, {
    persist: { // pinia-plugin-persistedstate package config. Handles dynamic two-way data binding with localstorage
      enabled: true,
      key: `johanniter-data-careconsulting2_${BRAND_THEME}`,
    }
  },
)
